/** JSDoc
 * @deprecated Use string literals - if you require type casting, cast to RequestSessionStatus type
 */
export enum RequestSessionStatus {
  /** JSDoc */
  Ok = 'ok',
  /** JSDoc */
  Errored = 'errored',
  /** JSDoc */
  Crashed = 'crashed',
}
